import React, { useEffect, useState } from 'react'
import { Box, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import QRCode from 'qrcode'

/**
 * کیوآرکد لینک سامانه در گوشهٔ چپِ پایین — فقط دسکتاپ.
 *
 * دو حالت:
 *  - 'full' (پنل ادمین): کارتِ همیشه‌نمایان ۱۳۲px — مستقیم دیده میشود
 *    (فضای پایین صفحه در Layout رزرو میشود).
 *  - 'mini' (بقیهٔ پنلها مثل سازمان): نشانِ کوچکِ ۵۶px همیشه‌نمایان که
 *    با هاور/کلیک باز میشود — تا محتوای صفحه (مثل کارت بارگذاری فایل)
 *    را نپوشاند.
 */
const AppQrCard = ({ variant = 'full' }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [qr, setQr] = useState('')
  const [open, setOpen] = useState(false)

  useEffect(() => {
    QRCode.toDataURL('https://arjanpeyman.ir', {
      width: 220,
      margin: 1,
      color: { dark: '#101a4d', light: '#ffffff' },
    })
      .then((url) => setQr(url))
      .catch(() => setQr(''))
  }, [])

  if (isMobile || !qr) return null

  const mini = variant === 'mini' && !open
  return (
    <Box
      onMouseEnter={variant === 'mini' ? () => setOpen(true) : undefined}
      onMouseLeave={variant === 'mini' ? () => setOpen(false) : undefined}
      onClick={variant === 'mini' ? () => setOpen((o) => !o) : undefined}
      style={{
        position: 'fixed',
        bottom: 18,
        left: 18,
        zIndex: 1050,
        background: '#fff',
        borderRadius: mini ? 999 : 14,
        border: '1px solid #e3e6f2',
        boxShadow: '0 8px 26px rgba(20,30,80,.16)',
        padding: mini ? 4 : '10px 12px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 6,
        width: mini ? 56 : 132,
        cursor: variant === 'mini' ? 'pointer' : undefined,
        overflow: 'hidden',
        transition: 'all .25s ease',
      }}
    >
      {mini ? (
        <img src={qr} alt="QR سامانه ارجان پیمان" style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover', display: 'block' }} />
      ) : (
        <>
          <img src={qr} alt="QR سامانه ارجان پیمان" style={{ width: 108, height: 108, borderRadius: 8 }} />
          <Typography style={{ fontSize: 10.5, fontWeight: 700, color: '#1a237e', textAlign: 'center', lineHeight: 1.7 }}>
            با موبایل اسکن کنید
            <br />
            <span style={{ fontWeight: 400, color: '#7a80a3', fontSize: 9.5 }}>باز شدن سامانه ارجان پیمان</span>
          </Typography>
        </>
      )}
    </Box>
  )
}

export default AppQrCard
